import { useState,useEffect } from "react";
import axios from "axios";
import MainLayout from "../layouts/MainLayout";
import AddDepartment from "./AddDepartment";
import EditDepartment from "./EditDepartment";

function Departments(){

const [departments,setDepartments]=useState([]);
const [search,setSearch]=useState("");

const [showAddDialog,setShowAddDialog]=useState(false);

const [showEditDialog,setShowEditDialog]=useState(false);

const [selectedDepartment,setSelectedDepartment]=useState(null);

useEffect(()=>{

loadDepartments();

},[]);

const loadDepartments=async()=>{

try{

const token=
localStorage.getItem(
"token"
);

const response=
await axios.get(

"https://saleupcall.com/api/Department/get-departments.php",

{
headers:{
Authorization:
`Bearer ${token}`
}
}

);

console.log(
response.data
);

if(response.data.status){

setDepartments(
response.data.data || []
);

}

}
catch(error){

console.log(
error
);

}

};

const filteredDepartments=

(departments || []).filter(

(item)=>

(item.department_name || "")
.toLowerCase()
.includes(
search.toLowerCase()
)

||

(item.description || "")
.toLowerCase()
.includes(
search.toLowerCase()
)

);

const deleteDepartment=async(id)=>{

if(
!window.confirm(
"Delete this department?"
)
){
return;
}

try{

const token=
localStorage.getItem(
"token"
);

const response=
await axios.post(

"https://saleupcall.com/api/Department/delete-department.php",

{
id:id
},

{
headers:{
Authorization:
`Bearer ${token}`
}
}

);

if(response.data.status){

alert(
"Department Deleted"
);

loadDepartments();

}

}
catch(error){

console.log(
error
);

}

};

return(

<MainLayout>

<div className="container mt-1">

<div className="row mb-2">

<div className="col-md-4">

<h4>

Departments

</h4>

</div>

<div className="col-md-6">

<input
type="text"
className="form-control form-control-sm"
placeholder="Search Department"
value={search}
onChange={(e)=>
setSearch(
e.target.value
)
}
/>

</div>

<div className="col-md-2">

<button
className="btn btn-success btn-sm w-100"
onClick={()=>
setShowAddDialog(
true
)
}
>

<i className="bi bi-plus-lg me-1"></i>

Add

</button>

</div>

</div>

<div className="table-responsive">

<table className="table table-bordered table-hover table-striped table-sm">

<thead className="table-success">

<tr>

<th>ID</th>
<th>Department</th>
<th>Description</th>
<th width="150">

Actions

</th>

</tr>

</thead>

<tbody>

{

filteredDepartments.map(

(item)=>(

<tr key={item.id}>

<td>

{item.id}

</td>

<td>

{item.department_name || "-"}

</td>

<td>

{item.description || "-"}

</td>

<td>

<button
className="btn btn-primary btn-sm me-1"
title="Edit"
onClick={()=>{

setSelectedDepartment(
item
);

setShowEditDialog(
true
);

}}
>

<i className="bi bi-pencil"></i>

</button>

<button
className="btn btn-danger btn-sm"
title="Delete"
onClick={()=>
deleteDepartment(
item.id
)
}
>

<i className="bi bi-trash"></i>

</button>

</td>

</tr>

)

)

}

</tbody>

</table>

</div>

</div>

{
showAddDialog && (

<div
className="modal d-block"
style={{
background:
"rgba(0,0,0,.5)"
}}
>

<div className="modal-dialog">

<div className="modal-content">

<div className="modal-header">

<h5>

Add Department

</h5>

<button
className="btn-close"
onClick={()=>
setShowAddDialog(
false
)
}
>

</button>

</div>

<div className="modal-body">

<AddDepartment
onClose={()=>{

setShowAddDialog(
false
);

loadDepartments();

}}
/>

</div>

</div>

</div>

</div>

)
}

{
showEditDialog &&
selectedDepartment && (

<div
className="modal d-block"
style={{
background:
"rgba(0,0,0,.5)"
}}
>

<div className="modal-dialog">

<div className="modal-content">

<div className="modal-header">

<h5>

Edit Department

</h5>

<button
className="btn-close"
onClick={()=>{

setShowEditDialog(
false
);

setSelectedDepartment(
null
);

}}
>

</button>

</div>

<div className="modal-body">

<EditDepartment
department={
selectedDepartment
}
onClose={()=>{

setShowEditDialog(
false
);

setSelectedDepartment(
null
);

loadDepartments();

}}
/>

</div>

</div>

</div>

</div>

)
}

</MainLayout>

);

}

export default Departments;